/*
 * ywv-snize-off.js - POD Hub (preview theme only)
 * Keeps Searchanise away from the native header search so Shopify's dropdown
 * (with the ywv-search-best tiles) is what shows, while Searchanise is still
 * installed on the store. Every step is a no-op once Searchanise is removed:
 *   - Searchanise binds its autocomplete to inputs carrying the class
 *     "snize-input-style"; we take that class off the header search input.
 *   - Searchanise rewrites the form action to its results page; we put the
 *     theme's own search URL back.
 *   - Searchanise also binds handlers straight onto the input (a keydown that
 *     preventDefaults Enter and the arrows) and the form (submit). We remove
 *     them through Searchanise's OWN jQuery instance (Searchanise.$), so no
 *     other script's handlers are touched. Re-checked on focus / keydown
 *     (capture phase, so it runs before their handler) and for 20s after load,
 *     because Searchanise initialises late.
 *   - On narrow screens Searchanise also binds click/touch on the header
 *     search ICON (the <summary>) to open its full-screen widget instead of
 *     the theme modal, through trusted click / mousedown / touchstart
 *     handlers on <body>. Those Searchanise handlers (and any it puts on the
 *     <summary>) are removed the same way. It also has a native click
 *     listener on the icon that stops the click, so while Searchanise is on the
 *     page we take the icon click in the capture phase and hand it straight to
 *     the theme's own <details-modal> (onSummaryClick), which opens the modal.
 * The CSS half (hide .snize-ac-results and the voice trigger, undo
 * #snize-custom-search-fix) lives in sections/header.liquid.
 */
(function () {
  'use strict';
  try {
    if (!window.MutationObserver) return;
    var searchUrl = (window.routes && window.routes.search_url) || '/search';

    function clean(input) {
      if (input.classList.contains('snize-input-style')) input.classList.remove('snize-input-style');
      var form = input.form;
      if (form && form.getAttribute('action') !== searchUrl) form.setAttribute('action', searchUrl);
    }

    function unbind(input) {
      var S = window.Searchanise;
      var $ = S && S.$;
      if (!$ || typeof $ !== 'function' || !$._data) return;
      if ($._data(input, 'events')) $(input).off();
      if (input.form && $._data(input.form, 'events')) $(input.form).off('submit');
    }

    function unbindToggles() {
      var S = window.Searchanise;
      var $ = S && S.$;
      if (!$ || typeof $ !== 'function' || !$._data) return;
      var body = document.body;
      if (body && $._data(body, 'events')) $(body).off('click mousedown touchstart');
      var toggles = document.querySelectorAll('details-modal.header__search summary');
      for (var i = 0; i < toggles.length; i++) {
        if ($._data(toggles[i], 'events')) $(toggles[i]).off();
      }
    }

    /* Searchanise only: run the theme modal's own toggle and keep the click from
       reaching Searchanise's listener. Without Searchanise the click is untouched. */
    function takeToggleClick(event) {
      try {
        sweepAll();
        if (!window.Searchanise) return;
        var modal = event.currentTarget.closest('details-modal');
        if (!modal || typeof modal.onSummaryClick !== 'function') return;
        event.stopImmediatePropagation();
        modal.onSummaryClick(event);
      } catch (e) {}
    }

    var sweepAll = function () {};

    function guard(input) {
      if (input.__ywvSnizeOff) return;
      input.__ywvSnizeOff = true;
      clean(input);
      var sweep = function () {
        try { clean(input); unbind(input); unbindToggles(); } catch (e) {}
      };
      sweepAll = sweep;
      sweep();
      input.addEventListener('focus', sweep, true);
      input.addEventListener('keydown', sweep, true);
      var toggles = document.querySelectorAll('details-modal.header__search summary');
      for (var t = 0; t < toggles.length; t++) {
        toggles[t].addEventListener('click', takeToggleClick, true);
        toggles[t].addEventListener('touchstart', sweep, true);
        toggles[t].addEventListener('mousedown', sweep, true);
        toggles[t].addEventListener('pointerdown', sweep, true);
      }
      var ticks = 0;
      var timer = setInterval(function () {
        sweep();
        if (++ticks >= 40) clearInterval(timer);
      }, 500);
      var observe = function () {
        try { clean(input); } catch (e) {}
      };
      new MutationObserver(observe).observe(input, { attributes: true, attributeFilter: ['class'] });
      if (input.form) new MutationObserver(observe).observe(input.form, { attributes: true, attributeFilter: ['action'] });
    }

    function init() {
      try {
        var inputs = document.querySelectorAll('predictive-search input[type="search"]');
        for (var i = 0; i < inputs.length; i++) guard(inputs[i]);
      } catch (e) {}
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) {}
})();
